module.exports = __webpack_public_path__ + "static/water_elemental-17e7248b30fe49d4be0983b7a7533958.jpg";